import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

//Modal
import StaffRfmsReportViewModal from './StaffRfmsReportViewModal';
import getLocale from '../../i18n/getLocale';


class StaffRfmsReportEvents extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      event: null,
      period: null,
      applicabilities_list: [],
      event_list: [
        { value: '1', label: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.opcoesEvento.Verde },
        { value: '2', label: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.opcoesEvento.Amarelo },
        { value: '3', label: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.opcoesEvento.Vermelho },
      ],
      period_list: [
        { value: '1', label: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.opcoesPeriodo.UmDia },
        { value: '2', label: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.opcoesPeriodo.DoisDias },
        { value: '3', label: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.opcoesPeriodo.TresDias },
      ],
      data_report_fatigues: [],
      date_start: '',
      date_finish: '',
      data_reports: undefined,
      fatigues_fields: undefined,
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.searchReports = this.searchReports.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            applicabilities_list: responseJson.data.applicabilities_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  searchReports(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      period: this.state.period,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      event: this.state.event,
      applicability_id: this.state.applicability_id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/eventos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data_reports: responseJson.data.reports, fatigues_fields: responseJson.data.fatigue_fields});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchReports}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label>{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.TipoDeEvento}:</label>
                    <Select
                        className="form-field-name"
                        name="event"
                        value={this.state.event}
                        searchable={true}
                        placeholder={this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.placeholder.DeixarEmBrancoParaTodos}
                        onChange={this.handleSelectChange.bind(this, 'event')}
                        options={this.state.event_list}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label>{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.AplicabilidadeTipoDeColaborador}:</label>
                    <Select
                        className="form-field-name"
                        name="applicability_id"
                        value={this.state.applicability_id}
                        searchable={true}
                        placeholder={this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.placeholder.SelecionarAplicabilidade}
                        onChange={this.handleSelectChange.bind(this, 'applicability_id')}
                        options={this.state.applicabilities_list}
                        required
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label>{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.PeriodoEstatisticoAnteriorAoEvento}:</label>
                    <Select
                        className="form-field-name"
                        name="event"
                        value={this.state.period}
                        searchable={true}
                        placeholder={this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.placeholder.SelecionarPeriodo}
                        onChange={this.handleSelectChange.bind(this, 'period')}
                        options={this.state.period_list}
                        required
                    />
                </div>
            </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.formulario.botaoProcurarRelatorios}</button>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.titulo}</h3>
      <hr/>
      
      {(self.state.fatigues_fields == undefined) ?
      '' 
      :

        <BootstrapTable data={self.state.data_reports} keyField={'staff_rfms_report_id'} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.EstatisticasDeEventosDeFadiga.tabela.semEventosDeFadigaParaEstePeriodo}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

          {
            self.state.fatigues_fields.map( column => {
              return (
                <TableHeaderColumn dataField={column.dataField} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='200'>{column.text}</TableHeaderColumn>
              );
            })
          }
        </BootstrapTable>
        
      }
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportEvents;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportEvents.js